// "Add" buttons in the cart upsell row (snippets/cart-upsell.liquid).
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-upsell-add]');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;

  // Only re-render the drawer when the click came from inside it; on /cart we reload the page.
  const drawer = btn.closest('cart-drawer');
  const body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
  if (drawer) body.sections = drawer.getSectionsToRender().map((s) => s.id);

  try {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) {
      btn.textContent = 'Unavailable';
      return;
    }
    if (drawer && data.sections) drawer.renderContents(data);
    else window.location.reload();
  } catch (err) {
    btn.disabled = false;
  }
});
